import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { EnrollmentDetails, EnrollmentNotificationHistory, EnrollmentPaymentActivity } from "@customTypes/masterclass";

import { masterclassQKeys } from "./queryKeys";


export const fetchEnrollmentDetails = async (id: string): Promise<EnrollmentDetails> =>
  (await api.get(`masterclass/enrollments/${id}/details`)).data;

export const useEnrollmentDetails = (id: string, enabled: boolean) => useQuery({
  queryKey: masterclassQKeys.enrollmentDetails(id),
  queryFn: () => fetchEnrollmentDetails(id),
  enabled: enabled && !!id,
  staleTime: 0,
});

export const useEnrollmentPayments = (id: string, page: number, enabled: boolean) => useQuery<EnrollmentPaymentActivity>({
  queryKey: masterclassQKeys.enrollmentActivity(id, "payments", page),
  queryFn: async () => (await api.get(`masterclass/enrollments/${id}/payment-activity`, { params: { page, page_size: 20 } })).data,
  enabled: enabled && !!id,
});

export const useEnrollmentNotifications = (id: string, page: number, enabled: boolean) => useQuery<EnrollmentNotificationHistory>({
  queryKey: masterclassQKeys.enrollmentActivity(id, "notifications", page),
  queryFn: async () => (await api.get(`masterclass/enrollments/${id}/notifications`, { params: { page, page_size: 20 } })).data,
  enabled: enabled && !!id,
});
